import { Sort } from "@planzone/dto";
import { Identifiable, SecondaryCriteria } from "@planzone/dto";

function isCustomCriteria(
  columnKey: string,
  template: Identifiable<SecondaryCriteria>[],
): boolean {
  return template.some(({ uuid }) => uuid === columnKey);
}

function buildCustomSort(columnKey: string, direction: "asc" | "desc"): Sort {
  return `customCriteria:${columnKey}:${direction}` as Sort;
}

export { isCustomCriteria, buildCustomSort };
